import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useProducts} from "@/hooks/useProducts";
import {ref, watch} from "vue";
import ProductsWithFilter from "@/components/common/products-with-filter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'recent-products',
  setup(__props) {

const page = ref(1);
watch(()=>page.value, ()=>console.log(page.value))
let {data: products, isLoading} = useProducts(page, 15, page);


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(ProductsWithFilter, {
        page: page.value,
        "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
        title: "New products",
        products: _unref(products),
        isLoading: _unref(isLoading)
      }, null, 8, ["page", "products", "isLoading"])
    ]),
    _: 1
  }))
}
}

})